/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "DigitalWalletSendVerificationRequest": {
                "fields": {
                  "notificationId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cardToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "communicationChannel": {
                    "type": ".squareup.corporate_card.service.DigitalWalletSendVerificationRequest.CommunicationChannel",
                    "id": 4,
                    "rule": "optional"
                  },
                  "passcode": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "expirationMinutes": {
                    "type": "int32",
                    "id": 6,
                    "rule": "optional"
                  },
                  "platform": {
                    "type": ".squareup.corporate_card.service.DigitalWalletSendVerificationRequest.Platform",
                    "id": 7,
                    "rule": "optional"
                  },
                  "emailAddress": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "CommunicationChannel": {
                    "values": {
                      "EMAIL": 1
                    }
                  },
                  "Platform": {
                    "values": {
                      "DO_NOT_USE_UNKNOWN": 0,
                      "APPLE_WALLET": 1,
                      "GOOGLE_WALLET": 2
                    }
                  }
                }
              },
              "DigitalWalletSendVerificationResponse": {
                "fields": {
                  "success": {
                    "type": ".squareup.corporate_card.service.DigitalWalletSendVerificationResponse.Success",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Success": {
                    "fields": {}
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.DigitalWalletSendVerificationRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.DigitalWalletSendVerificationRequest?.nested?.CommunicationChannel && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.DigitalWalletSendVerificationRequest?.nested?.Platform && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.DigitalWalletSendVerificationResponse && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.DigitalWalletSendVerificationResponse?.nested?.Success) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE DigitalWalletSendVerificationRequest @ squareup/corporate_card/service/digital_wallet_send_verification.proto at 10:1
 */
export const DigitalWalletSendVerificationRequest = $root.lookupType('squareup.corporate_card.service.DigitalWalletSendVerificationRequest');
fixType(DigitalWalletSendVerificationRequest, {
  notificationId: {
    notEmpty: true
  },
  cardToken: {
    required: true
  },
  merchantToken: {
    required: true
  },
  communicationChannel: {
    required: true
  },
  passcode: {
    notEmpty: true
  },
  expirationMinutes: {
    required: true
  }
});
Builder.createAndAttachToType(DigitalWalletSendVerificationRequest);
/**
 * SOURCE CommunicationChannel @ squareup/corporate_card/service/digital_wallet_send_verification.proto at 33:3
 */
DigitalWalletSendVerificationRequest.CommunicationChannel = $root.lookupEnum('squareup.corporate_card.service.DigitalWalletSendVerificationRequest.CommunicationChannel').values;
/**
 * SOURCE Platform @ squareup/corporate_card/service/digital_wallet_send_verification.proto at 37:3
 */
DigitalWalletSendVerificationRequest.Platform = $root.lookupEnum('squareup.corporate_card.service.DigitalWalletSendVerificationRequest.Platform').values;
/**
 * SOURCE DigitalWalletSendVerificationResponse @ squareup/corporate_card/service/digital_wallet_send_verification.proto at 44:1
 */
export const DigitalWalletSendVerificationResponse = $root.lookupType('squareup.corporate_card.service.DigitalWalletSendVerificationResponse');
fixType(DigitalWalletSendVerificationResponse);
Builder.createAndAttachToType(DigitalWalletSendVerificationResponse);
/**
 * SOURCE Success @ squareup/corporate_card/service/digital_wallet_send_verification.proto at 45:3
 */
DigitalWalletSendVerificationResponse.Success = $root.lookupType('squareup.corporate_card.service.DigitalWalletSendVerificationResponse.Success');
fixType(DigitalWalletSendVerificationResponse.Success);
Builder.createAndAttachToType(DigitalWalletSendVerificationResponse.Success);